<mat-toolbar color="primary" class="header" mat-elevation-z5>
    <span>
      <a><img class="cacau" src="../../../../assets/cacau2" /> </a>
    </span>
  
    <span class="title">
      <a>
        <h1>Animais App</h1>
      </a>
    </span>
  </mat-toolbar>